export interface LedgerAmount {
    value: number;
    currency?: string;
}

/** A booking's amount in another currency, shown on a line of its own under the booking. */
export interface LedgerForeignLine {
    amount: LedgerAmount;
    /** Base amount ÷ foreign amount. */
    rate: number;
    side: 'debit' | 'credit';
}

export interface LedgerBookingRow {
    kind: 'booking';
    id: string;
    date: string;
    text: string;
    accountNumber: string;
    accountLabel: string;
    vatCode?: string;
    debit?: LedgerAmount | null;
    credit?: LedgerAmount | null;
    balance: LedgerAmount;
    foreign?: LedgerForeignLine | null;
    /** The running balance in the account currency, on a foreign-currency account. */
    foreignBalance?: LedgerAmount | null;
    hasComment?: boolean;
}

export interface LedgerTitleRow {
    kind: 'title';
    id: string;
    date: string;
    variant: 'opening' | 'closing';
    balance: LedgerAmount;
    /** The balance in the account currency, on a foreign-currency account. */
    foreignBalance?: LedgerAmount | null;
    /** The account currency whose balance the ERP did not deliver — shown as not available. */
    foreignUnavailable?: string | null;
    hasComment?: boolean;
}

export type LedgerRow = LedgerBookingRow | LedgerTitleRow;
